import { MembersPage } from '@/imports/ui/admin/pages/people/MembersPage';
import { RouteRestrictions } from '@/utilities';
import { restrictedRoute } from '@/utilities/restrictedRoute';

export default restrictedRoute(MembersPage, {
  requiresEvery: [RouteRestrictions.ADMIN_ROLE],
});
